import React, { FC } from 'react';
import get from 'lodash/get';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import Select, { SimpleOption } from 'vibo-ui/Select';

import { useUsersFilterable } from '../UsersListContext';

import { GET_TIERS } from 'graphql/queries/admin';

import { GetTiersResponse } from 'components/modals/UpdateUserModal';

const TierFilter: FC = () => {
  const { t } = useTranslation();

  const { data: tiersData, loading: isTiersLoading } = useQuery<GetTiersResponse>(GET_TIERS, {
    fetchPolicy: 'network-only',
  });
  const tiers: Tier[] = get(tiersData, 'getTiers.tiers', []);

  const { filter, setFilter } = useUsersFilterable();

  const options = [
    { label: 'All', value: undefined },
    ...tiers.map(option => ({
      label: t(option.name),
      value: option._id,
    })),
  ];

  const handleChangeTier = (option: SimpleOption) => {
    setFilter((prev: UsersFilter) => ({
      ...prev,
      tiers: [option.value].filter(Boolean),
    }));
  };

  return (
    <Select
      onChange={handleChangeTier}
      value={filter?.tiers?.[0]}
      options={options}
      isDisabled={isTiersLoading}
      selectedValuePrefix="Tier"
      styleModificator="asLink"
      withCustomValueContainer
      hideDropdownIndicator
    />
  );
};

export default TierFilter;
